/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterNSmall = createReactComponent("outline", "letter-n-small", "IconLetterNSmall", [["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-0" }]]);

export { IconLetterNSmall as default };
//# sourceMappingURL=IconLetterNSmall.mjs.map
